import { render, staticRenderFns } from "./ReputationWidget.vue?vue&type=template&id=5bc1569c&scoped=true"
import script from "./ReputationWidget.vue?vue&type=script&lang=js"
export * from "./ReputationWidget.vue?vue&type=script&lang=js"
import style0 from "./ReputationWidget.vue?vue&type=style&index=0&id=5bc1569c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1569c",
  null
  
)

export default component.exports